export const API_URL = process.env.REACT_APP_API_HOST || 'http://localhost:8000';
export const PROJECT_WAITING = process.env.REACT_APP_WAITING || '';
export const CHAT_ID = process.env.REACT_APP_CHAT_ID;
export const BOLETOS_SERVICE_HOST = process.env.REACT_APP_BOLETOS_SERVICE_HOST || 'https://boleto-service-dev-api.educacionalagos.com.br/graphql/';
